'use client';

export { default } from './BottomNavigationAction';
export { default as bottomNavigationActionClasses } from './bottomNavigationActionClasses';
export * from './bottomNavigationActionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/BottomNavigationAction/index.js
// module id = 820
// module chunks = 22